// React

// Components
import { Card, Grid, Icon, MenuItem, Select, Tab, Tabs } from "@mui/material";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Data
import { gql, useQuery } from "@apollo/client";
import { useState } from "react";
import DatosPersonales from "./components/DatosPersonales";
import Resumen from "./components/Resumen";

function Autogestion() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedCarrera, setSelectedCarrera] = useState(null);
  const {
    data: usuario,
    loading,
    refetch,
  } = useQuery(gql`
    query getUser {
      currentUser {
        id
        tipoUser
        username
        nombre
        apellido
        email
        dni
        fechaNacimiento
        pais {
          id
        }
        genero
        telefono
        telefonoRespaldo
        localidad {
          id
          nombre
        }
        provincia {
          id
          nombre
        }
      }
    }
  `);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3} id="autogestion">
          <Card>
            <SoftBox
              p={3}
              display={{
                xs: "flex-row",
                sm: "flex",
              }}
              justifyContent="space-between"
            >
              <SoftBox
                mr={2}
                sx={{
                  width: "100%",
                }}
              >
                <Tabs
                  value={selectedTab}
                  onChange={(e, value) => {
                    setSelectedTab(value);
                    refetch();
                  }}
                >
                  <Tab
                    id="step-resumen"
                    label={
                      <SoftBox display="flex" alignItems="center">
                        <SoftBox display="flex" alignItems="center">
                          <Icon color={selectedTab === 0 ? "primary" : "secondary"}>
                            description
                          </Icon>
                        </SoftBox>
                        <SoftTypography
                          variant="h6"
                          fontWeight={selectedTab === 0 ? "bold" : "regular"}
                        >
                          Permisos
                        </SoftTypography>
                      </SoftBox>
                    }
                    value={0}
                  />
                  <Tab
                    id="step-datosPersonales"
                    label={
                      <SoftBox display="flex" alignItems="center">
                        <SoftBox display="flex" alignItems="center">
                          <Icon color={selectedTab === 2 ? "primary" : "secondary"}>
                            account_circle
                          </Icon>
                        </SoftBox>
                        <SoftTypography
                          variant="h6"
                          fontWeight={selectedTab === 2 ? "bold" : "regular"}
                        >
                          Perfil
                        </SoftTypography>
                      </SoftBox>
                    }
                    value={2}
                  />
                </Tabs>
              </SoftBox>
            </SoftBox>
            <Grid container spacing={2} p={3} pt={0}>
              <Grid item xs={12}>
                {selectedTab === 0 && (
                  <Resumen
                    usuario={usuario?.currentUser}
                    carrera={selectedCarrera}
                    loading={loading}
                    refetch={refetch}
                    setTab={setSelectedTab}
                  />
                )}
                {selectedTab === 2 && (
                  <DatosPersonales
                    selectedUsuario={usuario?.currentUser}
                    loading={loading}
                    refetch={refetch}
                  />
                )}
              </Grid>
            </Grid>
          </Card>
        </SoftBox>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Autogestion;
